import ability from '@/plugins/casl/ability';

export const can = (action, subject) => {
  const vm = getCurrentInstance();
  if (!vm) return false;
  const localCan = vm.proxy && '$can' in vm.proxy;

  return localCan ? vm.proxy?.$can(action, subject) : true;
};

// A child group (e.g. PPC inside Amazon) is visible when any descendant is, not by its own
// action/subject — it usually has none, and can(undefined, undefined) is not "allowed".
const canViewNavChild = (child) => {
  if (child.children) return child.children.some(canViewNavChild);
  return can(child.action, child.subject);
};

export const canViewNavMenuGroup = (item) => {
  const hasAnyVisibleChild = item.children.some(canViewNavChild);

  // If subject and action is defined in item => Return based on children visibility (Hide group if no child is visible)
  // Else check for ability using provided subject and action along with checking if has any visible child
  if (!(item.action && item.subject)) return hasAnyVisibleChild;

  return can(item.action, item.subject) && hasAnyVisibleChild;
};
export const canNavigate = (to) => {
  return to.matched.some((route) => ability.can(route.meta.action, route.meta.subject));
};
